import React, { useState } from 'react';

import { Popover } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { FaInfoCircle } from 'react-icons/fa';

const InfoBox = props => {
  const [anchor, setAnchor] = useState(null);
  const theme = useTheme();

  return (
    <i
      onMouseEnter={event => setAnchor(event.currentTarget)}
      onMouseLeave={() => setAnchor(null)}
      style={{ display: 'inline-flex' }}
    >
      <FaInfoCircle style={{ color: theme.palette.primary.main }} />

      <Popover
        style={{ pointerEvents: 'none' }}
        open={!!anchor}
        anchorEl={anchor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setAnchor(null)}
        disableRestoreFocus
      >
        <div style={{ padding: 30 }}>{props.children || ''}</div>
      </Popover>
    </i>
  );
};

export default InfoBox;
